import React from 'react';
import classnames from 'classnames';
import { measuredDefaultSize, MeasuredContainer, MeasuredCookieType } from '../Measured';
import DeviationsMosaic from '../DeviationsMosaic';
import StandardThumb from '../DeviationViews/Thumb/Standard';
import s from './MeasuredDeviationsMosaic.scss';
const defaultPadding = parseInt(s['padding']);
const MeasuredDeviationsMosaic = ({ deviations , contentClassName , className , cookieType =MeasuredCookieType.BROWSE , height =375 , padding =defaultPadding , deviationView =StandardThumb  })=>{
    return /*#__PURE__*/ React.createElement(MeasuredContainer, {
        cookieType: cookieType,
        cookieDim: 'width',
        defaultSize: measuredDefaultSize,
        listenOnWindow: true,
        limitToParentWidth: true,
        measureWindow: true
    }, (measuredProps)=>{
        return /*#__PURE__*/ React.createElement(DeviationsMosaic, {
            width: measuredProps.container ? measuredProps.container.width : measuredDefaultSize.mobile.width,
            height: height,
            deviations: deviations,
            contentClassName: classnames(contentClassName, s['default-padding']),
            className: className,
            padding: padding,
            deviationView: deviationView
        });
    });
};
MeasuredDeviationsMosaic.displayName = 'MeasuredDeviationsMosaic';
export default MeasuredDeviationsMosaic;
